export const ORDERS_APP_DEF_ID = '13e8d036-5516-6104-b456-c8466db39542';
export const MENUS_APP_DEF_ID = '13c1402c-27f2-d4ab-7463-ee7c89e07578';
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const CheckoutTypes = Object.freeze({
  MANUALLY: 'manually',
  PAY_PER_DISH: 'pay_per_dish',
});

export const PaymentTypes = Object.freeze({
  CASH: 'cash',
  CREDIT: 'credit',
});

export const DeliveryTypes = {
  DELIVERY: 'delivery',
  TAKEOUT: 'takeout',
};

export const Modals = Object.freeze({
  EDIT_DISH: 'editDish',
  CUSTOMER_INFORMATION: 'customerInformation',
  ADDRESS_INFORMATION: 'addressInformation',
  BRANCH_SELECTOR: 'branchSelector',
  ORDER_HISTORY: 'orderHistory',
  UNAVAILABLE_DISHES: 'unavailableDishes',
  CREDIT_CARD_IFRAME: 'creditCardIframe',
  ASSOCIATE_DISH_MODAL: 'associateDishModal',
  ORDER_CONFIRMATION: 'orderConfirmationModal',
  ORDER_PLACEMENT_ERROR: 'orderPlacementError',
  CANCEL_ORDER: 'cancelOrder',
  BACK_TO_DASHBOARD: 'backToDashboard',
  SETTINGS_CHANGED: 'settingsChanged',
  NAVIGATE_AWAY: 'navigateAway',
  CASHIER_WIDGET_MODAL: 'cashierWidgetModal',
});

export const DiscountUnits = Object.freeze({
  CURRENCY: 'currency',
  PERCENT: 'percent',
});

export const EMPTY_ADDRESS = { onArrival: 'buzz' };

export const EmptyStates = Object.freeze({
  NO_MENU: 'NO_MENU',
  OLO_OFF: 'OLO_OFF',
  OLO_UNAVAILABLE: 'OLO_UNAVAILABLE',
  NO_PAYMENTS: 'NO_PAYMENTS',
  NO_PREMIUM: 'NO_PREMIUM',
  NO_REST_ADDRESS: 'NO_ADDRESS',
  NO_SEARCH_RESULTS: 'NO_SEARCH_RESULTS',
});

export const CASHIER_RETURN_URL =
  'https://www.wix.com/cashier-settings-server/payment-provider-continuePayment-complete';
